const actions = {
  CREATE_VIDEOSOURCE_BEGIN: 'CREATE_VIDEOSOURCE_BEGIN',
  CREATE_VIDEOSOURCE: 'CREATE_VIDEOSOURCE',
  CREATE_VIDEOSOURCE_ERR: 'CREATE_VIDEOSOURCE_ERR',
  CREATE_VIDEOSOURCE_EMPTY: 'CREATE_VIDEOSOURCE_EMPTY',

  FETCH_ALL_VIDEOSOURCE_LIST_BEGIN: 'FETCH_ALL_VIDEOSOURCE_LIST_BEGIN',
  FETCH_ALL_VIDEOSOURCE_LIST: 'FETCH_ALL_VIDEOSOURCE_LIST',
  FETCH_ALL_VIDEOSOURCE_LIST_ERR: 'FETCH_ALL_VIDEOSOURCE_LIST_ERR',

  FETCH_VIDEOSOURCE_DETAILS_BEGIN: 'FETCH_VIDEOSOURCE_DETAILS_BEGIN',
  FETCH_VIDEOSOURCE_DETAILS: 'FETCH_VIDEOSOURCE_DETAILS',
  FETCH_VIDEOSOURCE_DETAILS_ERR: 'FETCH_VIDEOSOURCE_DETAILS_ERR',

  UPDATE_VIDEOSOURCE_DETAILS_BEGIN: 'UPDATE_VIDEOSOURCE_DETAILS_BEGIN',
  UPDATE_VIDEOSOURCE_DETAILS: 'UPDATE_VIDEOSOURCE_DETAILS',
  UPDATE_VIDEOSOURCE_DETAILS_ERR: 'UPDATE_VIDEOSOURCE_DETAILS_ERR',
  UPDATE_VIDEOSOURCE_DETAILS_EMPTY: 'UPDATE_VIDEOSOURCE_DETAILS_EMPTY',

  createVideoSourceBegin: () => {
    return {
      type: actions.CREATE_VIDEOSOURCE_BEGIN,
    };
  },

  createVideoSource: (data) => {
    return {
      type: actions.CREATE_VIDEOSOURCE,
      data,
    };
  },
  createVideoSourceErr: (err) => {
    return {
      type: actions.CREATE_VIDEOSOURCE_ERR,
      err,
    };
  },
  createVideoSourceEmpty: (err) => {
    return {
      type: actions.CREATE_VIDEOSOURCE_EMPTY,
      err,
    };
  },

  fetchAllVideoSourceListBegin: () => {
    return {
      type: actions.FETCH_ALL_VIDEOSOURCE_LIST_BEGIN,
    };
  },

  fetchAllVideoSourceList: (data) => {
    return {
      type: actions.FETCH_ALL_VIDEOSOURCE_LIST,
      data,
    };
  },
  fetchAllVideoSourceListErr: (err) => {
    return {
      type: actions.FETCH_ALL_VIDEOSOURCE_LIST_ERR,
      err,
    };
  },

  fetchVideoSourceDetailsBegin: () => {
    return {
      type: actions.FETCH_VIDEOSOURCE_DETAILS_BEGIN,
    };
  },

  fetchVideoSourceDetails: (data) => {
    return {
      type: actions.FETCH_VIDEOSOURCE_DETAILS,
      data,
    };
  },
  fetchVideoSourceDetailsErr: (err) => {
    return {
      type: actions.FETCH_VIDEOSOURCE_DETAILS_ERR,
      err,
    };
  },

  updateVideoSourceDetailsBegin: () => {
    return {
      type: actions.UPDATE_VIDEOSOURCE_DETAILS_BEGIN,
    };
  },

  updateVideoSourceDetails: (data) => {
    return {
      type: actions.UPDATE_VIDEOSOURCE_DETAILS,
      data,
    };
  },
  updateVideoSourceDetailsErr: (err) => {
    return {
      type: actions.UPDATE_VIDEOSOURCE_DETAILS_ERR,
      err,
    };
  },
  updateVideoSourceDetailsEmpty: () => {
    return {
      type: actions.UPDATE_VIDEOSOURCE_DETAILS_EMPTY,
    };
  },
};

export default actions;
